
import { defineComponent, ref, watch, watchEffect } from 'vue'
import EditableField from '@/components/_shared/editable-field.vue'
import { urlRule, useFormModule } from '@/modules/_shared/forms'
import QForm from 'quasar/src/components/form/QForm.js';
import { useOrganizationModule } from '@/modules/organizations'
import { useRoute } from 'vue-router'

const validImageUrlRule = (val: string) => {
    const url = new URL(val)
    return url.protocol === 'https:' && url.hostname
        ? true
        : 'Invalid URL'
}
export default defineComponent({
    name: 'organizations-editable-field-logo-url',
    props: {
        modelValue: {
            type: String,
            required: false
        }
    },
    components: {
        EditableField
    },
    setup (props, { emit }) {
        const route = useRoute()
        const { updateOrganizationLogoUrl } = useOrganizationModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const localValue = ref(props.modelValue)
        const form = ref<QForm>()

        watchEffect(() => {
            localValue.value = props.modelValue
        })

        const sendRequest = async () => updateOrganizationLogoUrl(
            route.params.organizationId as string,
            {
                logoUrl: localValue.value ? localValue.value : null
            })

        watch(localValue, () => {
            submitForm(
                form.value,
                sendRequest,
                () => {
                    emit('update:modelValue', localValue.value)
                    createOnSuccess('Organization logo URL updated')()
                }
            )
        })

        return {
            localValue,
            form,
            validationRules: [urlRule]
        }
    }
})
